module.exports = __webpack_public_path__ + "media/images/admin/login-bg-6b8113707015ac4761ce456a2902014f.jpg";